import { Component, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { NextPage } from '@cvx/nextpage';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';


import { finalize, catchError } from 'rxjs';
import { of } from 'rxjs';
import { AIRService } from '../../../services/air.service';
import { AirInstalledTabComponent } from '../air-installed-tab/air-installed-tab.component';
import { AirRemovedTabComponent } from '../air-removed-tab/air-removed-tab.component';
import { AirInstalledSaveTabComponent } from '../air-installed-save-tab/air-installed-save-tab.component';
import { AirRemovedSaveTabComponent } from '../air-removed-save-tab/air-removed-save-tab.component';

@Component({
    selector: 'app-air',
    imports: [DropdownModule, TableModule, ButtonModule, NextPage, AirInstalledTabComponent,
        AirRemovedTabComponent, AirInstalledSaveTabComponent, AirRemovedSaveTabComponent],
    templateUrl: './air.component.html',
    styleUrl: './air.component.scss',
    providers: [AIRService]
})
export class AirComponent implements OnInit {
  tabList = ['Installed', 'Removed']
  tabContent: SafeHtml[] = [];
  installedData = [
    { division: 'Blending And Shipping ABU', section: 'Blending Section', tlr: '00789', status: 'Installed' }
  ]
  removedData = [
    { division: 'Blending And Shipping ABU', section: 'Blending Section', tlr: '00789', status: 'Removed' }
  ]

  installedHTML =
    `
  <div class="tab-section">
  <p-table [value]="installedData" [scrollable]="true" scrollHeight="400px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Division</th>
                            <th>DiviSectionsion</th>
                            <th>TLR#</th>
                            <th>TLR Status</th>
                            <th></th>
                            <th></th>
                            </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{row.division}}</td>
                            <td>{{row.section}}</td>
                            <td>{{row.tlr}}</td>
                            <td>{{row.status}}</td>
                            <td><a>Details</a></td>
                            <td><a>Assign</a></td>
                            </tr>
                        </ng-template>
                    </p-table>
  </div>
  `;
  removedHTML =
    `
  <div class="tab-section">
  <p-table [value]="removedData" [scrollable]="true" scrollHeight="400px">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Division</th>
                            <th>DiviSectionsion</th>
                            <th>TLR#</th>
                            <th>TLR Status</th>
                            <th></th>
                            <th></th>
                            </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{row.division}}</td>
                            <td>{{row.section}}</td>
                            <td>{{row.tlr}}</td>
                            <td>{{row.status}}</td>
                            <td><a>Details</a></td>
                            <td><a>Assign</a></td>
                            </tr>
                        </ng-template>
                    </p-table>
  </div>
  `
  airAPIData: any;
  isLoading: boolean = false;

  constructor(private airService: AIRService) {

  }
  ngOnInit() {
    this.isLoading = true;
    this.airService.getAIRData()
      .pipe(
        finalize(() => {
          this.isLoading = false;
        }),
        catchError(error => {
          return of({
            airOverviewData: [],
            messageNoAIRInstalled: 'No AIR installed data available',
            messageNoAIRRemoved: 'No AIR removed data available',
            messageAIRWithCALRemoved: 'No AIR with CAL removed data available'
          });
        })
      )
      .subscribe({
        next: (data: any) => {
          this.airAPIData = data;

          // Update local data if API returned valid data
          
        }
      });
  }
}

